export const getScriptByAttributeSelector = (attrSelector: string): Element | null => {
	return document.querySelector(`script[${attrSelector}]`);
};
